import { VlRouteBase } from '@vuelib/components';

export default /** @type { import('vue-router').RouteConfig } */ ({
  path: 'myusers',
  component: VlRouteBase,
  meta: {},
  children: [
    {
      path: '',
      name: 'myUserList',
      component: () => import('@/views/myusers/index.vue'),
      meta: {
        roles: ['admin', 'developer', 'support', 'company'],
      },
    },
    {
      path: ':userId/applications',
      name: 'myUserApplications',
      props: true,
      component: () => import('@/views/myusers/applications/index.vue'),
      meta: {
        roles: ['admin', 'developer', 'support', 'company'],
      },
    },
  ],
});
